import React from 'react';
import { Text, View, StyleSheet, TextInput } from 'react-native';
import i18n from 'i18n-js';

import TouchableElement from '@components/common/touchableElement';
import { isPhone, isWeb } from '@helpers';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import Svg from '@styles/icons/svg';

import { SmallLoading } from '@components/loading';
import {
  INPUT_LINE_HEIGHT,
  LINE_HORIZONTAL_PADDING,
  LINE_HORIZONTAL_PADDING_WITH_ACTION_ARROW,
  SCREEN_BORDER_RADIUS,
} from '../../../../../v2/pages/common/constants/base.constants';

export default ({
  data,
  index,
  i,
  editValue = () => {},
  C,
  font = initialFont,
  scale = initialScale,
  endLine = false,
  borderBottomRadius = false,
  borderTopRadius = false,
  onlyLabel = false,
  loading = false,
  layoutForPhone = false,
  rightSideTakesAllSpace = false,
  withoutStretchingForContainer = false,
  disableFlexConfForValueComponentMobile = false,
  borderRadiusValue = SCREEN_BORDER_RADIUS,
  bg = 'Background/Light/Field',
  flexForRightColumn = 2,
  containerWidth,
  withoutArrow = false,
  testID,
}) => {
  const _isPhone = isPhone || layoutForPhone;
  return (
    <TouchableElement
      testID={testID}
      onPress={() => {
        if (i.action) {
          i.action();
        }
      }}
      hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }}
    >
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            {
              paddingLeft: scale(15),
              backgroundColor: C(i.action ? pressHoverColor(bg) : bg),
            },
            borderBottomRadius && {
              borderBottomLeftRadius: scale(borderRadiusValue),
              borderBottomRightRadius: scale(borderRadiusValue),
            },
            borderTopRadius && {
              borderTopLeftRadius: scale(borderRadiusValue),
              borderTopRightRadius: scale(borderRadiusValue),
            },
            { flexDirection: 'row', alignItems: 'center' },
            !withoutStretchingForContainer && { flex: 1 },
            containerWidth && { maxWidth: containerWidth },
          ]}
        >
          <View
            style={{
              flex: 1,
              borderBottomColor: C('Hairline/Light/Secondary'),
              borderBottomWidth: endLine ? StyleSheet.hairlineWidth : data.length - 1 === index ? 0 : StyleSheet.hairlineWidth,
              flexDirection: 'row',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <View
              style={[
                boxStyle,
                {
                  flex: 1,
                  height: scale(i.height || INPUT_LINE_HEIGHT),
                  alignItems: 'center',
                  flexDirection: 'row',
                },
              ]}
            >
              <View
                style={[
                  { height: '100%', flexDirection: 'row', alignItems: 'center', flex: 1 },
                  _isPhone && !rightSideTakesAllSpace && { justifyContent: 'space-between' },
                ]}
              >
                <View
                  style={[
                    (!isPhone || i.Component || (i.value != null && !withoutStretchingForContainer)) && !rightSideTakesAllSpace && { flex: 1 },
                    rightSideTakesAllSpace && { flexShrink: 0 },
                    _isPhone && { paddingRight: scale(12), maxWidth: '100%' },
                  ]}
                >
                  {i.Component ? (
                    i.Component()
                  ) : (
                    <Text numberOfLines={1} style={[{ color: C('Label/Light/Primary') }, font.Body]}>
                      {i18n.t(i.name)}
                    </Text>
                  )}
                </View>
                {!onlyLabel && (i.action || i.isText || i.value != null || i.showAlert || i.ValueComponent) && (
                  <View
                    style={[
                      !disableFlexConfForValueComponentMobile && { flex: _isPhone ? 1 : flexForRightColumn },
                      { flexDirection: 'row', alignItems: 'center' },
                    ]}
                  >
                    <View style={[!disableFlexConfForValueComponentMobile && { flex: 1 }, { justifyContent: 'center', alignItems: 'center' }]}>
                      {i.action || i.isText || i.ValueComponent ? (
                        loading ? (
                          <View
                            style={[
                              { width: '100%', flexDirection: 'row' },
                              _isPhone && { justifyContent: 'flex-end', paddingRight: scale(LINE_HORIZONTAL_PADDING) },
                            ]}
                          >
                            <SmallLoading />
                          </View>
                        ) : (
                          <View style={[{ width: '100%', flexDirection: 'row', alignItems: 'center' }, _isPhone && { justifyContent: 'flex-end' }]}>
                            {i.showAlert && (
                              <View
                                style={{
                                  width: scale(24),
                                  height: scale(24),
                                  borderRadius: scale(24) / 2,
                                  backgroundColor: C(i.iconBackground),
                                  justifyContent: 'center',
                                  alignContent: 'center',
                                  alignItems: 'center',
                                  marginRight: scale(9),
                                }}
                              >
                                <Svg icon={i.iconName} width={17} height={11} color={i.iconColor} />
                              </View>
                            )}
                            {i.value != null && (
                              <Text
                                numberOfLines={1}
                                style={[
                                  {
                                    color: C('Label/Light/Tertiary'),
                                    textAlign: 'right',
                                    paddingRight: scale(
                                      i.action && !withoutArrow ? LINE_HORIZONTAL_PADDING_WITH_ACTION_ARROW : LINE_HORIZONTAL_PADDING
                                    ),
                                    alignSelf: 'center',
                                  },
                                  isWeb && { border: 'none', outline: 'none' },
                                  font.Body,
                                ]}
                              >
                                {i18n.t(i.value)}
                              </Text>
                            )}
                            {i.ValueComponent && (
                              <View
                                style={[
                                  {
                                    width: '100%',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    paddingRight: scale(
                                      i.action && !withoutArrow ? LINE_HORIZONTAL_PADDING_WITH_ACTION_ARROW : LINE_HORIZONTAL_PADDING
                                    ),
                                  },
                                  _isPhone && { justifyContent: 'flex-end' },
                                ]}
                              >
                                {i.ValueComponent}
                              </View>
                            )}
                          </View>
                        )
                      ) : (
                        <TextInput
                          onChangeText={(t) => editValue(t, i.name)}
                          autoCapitalize={'none'}
                          style={[
                            {
                              color: C('Label/Light/Tertiary'),
                              minWidth: '100%',
                              width: '100%',
                            },
                            isWeb && { border: 'none', outline: 'none' },
                            _isPhone && {
                              textAlign: 'right',
                              paddingRight: scale(15),
                            },
                            font.Body,
                          ]}
                          value={i18n.t(i.value)}
                          editable={false}
                        />
                      )}
                    </View>
                    {!loading && i.action && !withoutArrow && (
                      <View style={{ paddingRight: scale(16), height: '100%' }}>
                        <Svg icon="chevronRightLight" color="Label/Light/Quinary" width={scale(7)} height={scale(12)} />
                      </View>
                    )}
                  </View>
                )}
              </View>
            </View>
          </View>
        </View>
      )}
    </TouchableElement>
  );
};
